import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

export type ComponentTableDebugJsonDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  displayName: string
  storeJson: string
  clientJson: string
}

export function ComponentTableDebugJsonDialog({
  open,
  onOpenChange,
  displayName,
  storeJson,
  clientJson,
}: ComponentTableDebugJsonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90vw] max-w-5xl max-h-[90vh] overflow-hidden border-0 shadow-none ring-0 outline-none">
        <DialogHeader>
          <DialogTitle>Collection JSON: {displayName}</DialogTitle>
          <DialogDescription>
            Raw Redux store snapshot and client data currently loaded for this collection.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 max-h-[65vh] overflow-y-auto">
          <div>
            <p className="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400 mb-2">
              Store
            </p>
            <pre className="text-xs bg-gray-50 dark:bg-gray-900/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700 overflow-x-auto">
              <code>{storeJson || "// Store data not available for this collection"}</code>
            </pre>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400 mb-2">
              Client
            </p>
            <pre className="text-xs bg-gray-50 dark:bg-gray-900/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700 overflow-x-auto">
              <code>{clientJson || "// Client data not available for this collection"}</code>
            </pre>
          </div>
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
